// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3bF94","header":"MergedInvoice_header__3SFhz"};